module.exports = __webpack_public_path__ + "media/images/mypage/icon/green/ico_card-997af35f8f968aeaafd622eb5862a559.svg";